// deps
import { useRef } from "react";
import { useCalendarCell } from "@react-aria/calendar";
import { isSameMonth } from "@internationalized/date";
import { Button, Box } from "@chakra-ui/react";
import PropTypes from "prop-types";

/**
 * @typedef Props
 * @property {import("@react-stately/calendar").CalendarState} state
 * @property {object} date
 * @property {object} currentMonth
 * @property {import("react").Dispatch<import("react").SetStateAction<any>>} setOpen
 * @property {boolean} shouldCloseOnDaySelect
 */
/**
 * @returns {import("react").FunctionComponentElement<Props>}
 */
export function CalendarCell({
  state,
  date,
  currentMonth,
  setOpen,
  shouldCloseOnDaySelect,
}) {
  let ref = useRef(null);
  let { cellProps, buttonProps, isSelected, isInvalid, formattedDate } =
    useCalendarCell({ date }, state, ref);

  let isOutsideMonth = !isSameMonth(currentMonth, date);

  function onCellClick() {
    if (shouldCloseOnDaySelect) {
      setOpen(false);
    }
  }

  return (
    <Box as="td" {...cellProps} textAlign="center">
      <Button
        {...buttonProps}
        ref={ref}
        hidden={isOutsideMonth}
        size="sm"
        colorScheme={isInvalid ? "red" : "blue"}
        variant={isSelected ? "solid" : "ghost"}
        onClick={onCellClick}
        width="100%">
        {formattedDate}
      </Button>
    </Box>
  );
}

export default CalendarCell;

CalendarCell.propTypes = {
  state: PropTypes.object,
  date: PropTypes.object,
  currentMonth: PropTypes.object,
  setOpen: PropTypes.func,
  shouldCloseOnDaySelect: PropTypes.bool,
};
